// import React, { useEffect, useRef, useState } from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import "./Features.css";
// import imgGirl from "../../../Assets/main-image.png";
// import { dataDigitalBestSeller } from "../../../data";
// import "./Features.css";
// const Features = () => {
//   const [defaultImage, setDefaultImage] = useState({});
//   const sliderRef = useRef(null);

//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 3,
//     slidesToScroll: 3,
//     initialSlide: 0,
//     autoplay: false,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 2,
//           infinite: true,
//           dots: true,
//         },
//       },
//       {
//         breakpoint: 600,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 2,
//           initialSlide: 2,
//         },
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         },
//       },
//     ],
//     nextArrow: <NextArrow />,
//     prevArrow: <PrevArrow />,
//     beforeChange: (current, next) => {
//       if (next >= dataDigitalBestSeller.length) {
//         goToSlide(0);
//       }
//     },
//   };

//   const handleErrorImage = (data) => {
//     setDefaultImage((prev) => ({
//       ...prev,
//       [data.target.alt]: data.target.alt,
//       linkDefault: imgGirl,
//     }));
//   };
//   const goToSlide = (slideIndex) => {
//     sliderRef.current.slickGoTo(slideIndex);
//   };
//   const goToNextSlide = () => {
//     sliderRef.current.slickNext();
//   };

//   const goToPrevSlide = () => {
//     sliderRef.current.slickPrev();
//   };

//   useEffect(() => {
//     const interval = setInterval(goToNextSlide, 5000);

//     return () => clearInterval(interval);
//   }, []);
//   return (
//     <>
//       <div className="features">
//         <p className="feature-heading">Features</p>
//         <p className="headingf">
//           Manage health, wealth and find community services that matches your
//           lifestyle.
//         </p>
//       </div>
//       <div className="App">
//         <Slider ref={sliderRef} {...settings}>
//           {" "}
//           {dataDigitalBestSeller.map((item) => (
//             <div key={item.title} className="card">
//               {" "}
//               <div className="card-top">
//                 <img
//                   src={
//                     defaultImage[item.title] === item.title
//                       ? defaultImage.linkDefault
//                       : item.linkImg
//                   }
//                   alt={item.title}
//                   onError={handleErrorImage}
//                 />
//                 <h1>{item.title}</h1>
//               </div>
//               <div className="card-bottom">
//                 <h3>{item.description}</h3>
//               </div>
//             </div>
//           ))}
//         </Slider>
//         <button className="slider-btn prev-btn" onClick={goToPrevSlide}>
//           <svg
//             width="24"
//             height="25"
//             viewBox="0 0 24 25"
//             fill="none"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <path
//               d="M10.7566 12.3005L15.7066 17.2505C15.8021 17.3427 15.8783 17.4531 15.9307 17.5751C15.9831 17.6971 16.0107 17.8283 16.0118 17.9611C16.013 18.0939 15.9877 18.2255 15.9374 18.3484C15.8871 18.4713 15.8128 18.583 15.719 18.6769C15.6251 18.7708 15.5134 18.845 15.3905 18.8953C15.2676 18.9456 15.1359 18.9709 15.0032 18.9697C14.8704 18.9686 14.7392 18.941 14.6172 18.8886C14.4952 18.8362 14.3848 18.76 14.2926 18.6645L8.63556 13.0075C8.44809 12.8199 8.34277 12.5656 8.34277 12.3005C8.34277 12.0353 8.44809 11.781 8.63556 11.5935L14.2926 5.93647C14.4812 5.75432 14.7338 5.65352 14.996 5.6558C15.2582 5.65808 15.509 5.76325 15.6944 5.94865C15.8798 6.13406 15.985 6.38488 15.9872 6.64707C15.9895 6.90927 15.8887 7.16187 15.7066 7.35047L10.7566 12.3005Z"
//               fill="#1B1F27"
//             />
//           </svg>
//         </button>
//         <button className="slider-btn next-btn" onClick={goToNextSlide}>
//           <svg
//             width="25"
//             height="25"
//             viewBox="0 0 25 25"
//             fill="none"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <path
//               d="M13.7112 12.3713L8.76118 7.42127C8.57902 7.23267 8.47823 6.98007 8.48051 6.71787C8.48278 6.45568 8.58795 6.20486 8.77336 6.01946C8.95877 5.83405 9.20958 5.72888 9.47178 5.7266C9.73398 5.72432 9.98658 5.82512 10.1752 6.00727L15.8322 11.6643C16.0197 11.8518 16.125 12.1061 16.125 12.3713C16.125 12.6364 16.0197 12.8907 15.8322 13.0783L10.1752 18.7353C9.98658 18.9174 9.73398 19.0182 9.47178 19.0159C9.20958 19.0137 8.95877 18.9085 8.77336 18.7231C8.58795 18.5377 8.48278 18.2869 8.48051 18.0247C8.47823 17.7625 8.57902 17.5099 8.76118 17.3213L13.7112 12.3713Z"
//               fill="#1B1F27"
//             />
//           </svg>
//         </button>
//       </div>
//     </>
//   );
// };

// const NextArrow = (props) => {
//   const { className, onClick } = props;
//   return <div onClick={onClick}></div>;
// };

// const PrevArrow = (props) => {
//   const { className, onClick } = props;
//   return <div onClick={onClick}></div>;
// };

// export default Features;

import React from "react";
import team from "../../../Assets/team.jpeg";
import "./Features.css";
import { useNavigate } from "react-router-dom";

const Features = () => {
  const naviagate = useNavigate();
  const handleRegisterClick =()=>{
    naviagate("/installApp");
  }
  return (
    // <section class="feature-container background-color-green">
    //   <div class="f-container">
    //     <div className="f-heading">
    //       <p>
    //         Werde Teil deiner lokalen <br />
    //         Community!
    //       </p>
    //       <p>
    //         Lorem ipsum dolor sit <br />
    //         consectetur
    //       </p>
    //     </div>
    //     <figure className="f-figure">
    //       <img src={image} alt="jogging" loading="lazy" className="f-image" />
    //     </figure>
    //   </div>
    // </section>
    <div>
      <div className="feature-section background-color-green">
        <div className="feature-container">
          <div className="f-left-container">
            <h1 className="f-heading">
              BECOME PART OF YOUR <br />
              <span style={{ color: "pink" }}>LOCAL </span>
              COMMUNITY!
            </h1>
            <p className="f-subheading">
              Your neighborhood comes together at Apna Konnect.
              Be there
            </p>
            {/* <p className="f-span">
              Experience the real connect with your neighborhood on APNA KONNECT
            </p> */}
            <button className="btn-show-less Acc-button" style={{background:"#00AC73", color:"#fff"}} onClick={()=>naviagate("/installApp")}>REGISTER NOW</button>
          </div>
          <img src={team} className="f-image" />
        </div>
      </div>
      <div class="Ps7O6GY3PT5hQ5evKbe5">
        <div class="lhe7D12ocC8dqa7nVWSl">
          <h5 class="pTxwDVMI6rC_geo2fLo8 EXJYCSOU5l6X2xNCgrfH j40Lpa_11jxj26o6XX_S">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 38 40"
              class="eQtQSMDJkR4BT1TaqVTY"
            >
              <mask
                id="a"
                width="38"
                height="40"
                x="0"
                y="0"
                fill="currentColor"
                maskUnits="userSpaceOnUse"
              >
                <path d="M0 0h38v40H0z"></path>
                <path d="M18.998 39c-1.518 0-2.89-.858-3.589-2.242l-.014.002c-.411-.822-.837-1.296-1.3-1.448-.457-.148-1.077-.022-1.885.396l-.012-.01a3.97 3.97 0 0 1-4.204-.327c-1.227-.906-1.84-2.418-1.603-3.95l-.012-.01c.28-1.802-.198-2.472-1.97-2.753l-.003-.016a4.033 4.033 0 0 1-3.208-2.773 4.117 4.117 0 0 1 .99-4.151l-.004-.014c1.27-1.29 1.27-2.117 0-3.408l.005-.014a4.117 4.117 0 0 1-.991-4.153 4.039 4.039 0 0 1 3.208-2.77l.004-.015c1.771-.285 2.25-.955 1.97-2.755l.013-.008c-.238-1.534.375-3.046 1.602-3.952a3.974 3.974 0 0 1 4.204-.328l.011-.008c.806.418 1.423.547 1.886.395.462-.152.888-.626 1.3-1.448l.015.002C16.108 1.858 17.481 1 18.998 1c1.518 0 2.893.858 3.59 2.242l.015-.002c.411.822.836 1.294 1.299 1.448.462.153 1.077.023 1.886-.395l.01.01a3.967 3.967 0 0 1 4.205.328c1.225.904 1.84 2.416 1.604 3.952l.013.007c-.282 1.8.197 2.47 1.969 2.756l.004.014a4.036 4.036 0 0 1 3.209 2.77 4.114 4.114 0 0 1-.99 4.154l.005.014c-1.27 1.289-1.27 2.117 0 3.407l-.006.015c1.08 1.1 1.46 2.69.99 4.153a4.038 4.038 0 0 1-3.21 2.77l-.002.016c-1.772.284-2.251.953-1.97 2.754l-.012.008c.235 1.535-.377 3.047-1.606 3.952a3.97 3.97 0 0 1-4.202.327l-.011.01c-.808-.42-1.424-.548-1.886-.396-.463.154-.888.627-1.3 1.447l-.015-.001c-.696 1.382-2.07 2.24-3.589 2.24Zm-2.2-2.974c.427.857 1.27 1.39 2.2 1.39.932 0 1.774-.531 2.2-1.39l.017.002c.607-1.208 1.328-1.935 2.205-2.221.873-.287 1.877-.13 3.066.484l.01-.01a2.424 2.424 0 0 0 2.583-.19 2.518 2.518 0 0 0 .979-2.44l.014-.009c-.407-2.636.659-4.123 3.254-4.546l.003-.015a2.475 2.475 0 0 0 1.984-1.696 2.53 2.53 0 0 0-.62-2.56l.004-.016c-1.855-1.89-1.855-3.727.001-5.616l-.006-.014c.673-.68.911-1.66.621-2.56a2.476 2.476 0 0 0-1.984-1.698l-.003-.014c-2.595-.425-3.661-1.911-3.254-4.548l-.014-.006a2.52 2.52 0 0 0-.977-2.441 2.428 2.428 0 0 0-2.584-.19l-.01-.01c-1.194.614-2.195.773-3.069.483-.875-.288-1.596-1.015-2.203-2.221H21.2c-.428-.859-1.27-1.39-2.202-1.39-.93 0-1.773.531-2.2 1.39h-.014c-.61 1.204-1.33 1.931-2.206 2.22-.875.288-1.876.13-3.067-.484l-.011.008a2.433 2.433 0 0 0-2.583.19 2.521 2.521 0 0 0-.976 2.443l-.015.008c.406 2.637-.659 4.123-3.255 4.546l-.003.014a2.479 2.479 0 0 0-1.983 1.698c-.29.9-.05 1.882.623 2.56l-.007.014c1.854 1.89 1.854 3.727 0 5.618l.007.014a2.528 2.528 0 0 0-.623 2.559c.288.9 1.047 1.55 1.983 1.697l.003.016c2.595.423 3.66 1.91 3.255 4.546l.013.01c-.152.95.222 1.883.977 2.44a2.43 2.43 0 0 0 2.584.19l.01.009c1.19-.613 2.192-.765 3.067-.485.875.288 1.596 1.015 2.205 2.221h.016Z"></path>
              </mask>
              <path
                fill="currentColor"
                d="M18.998 39c-1.518 0-2.89-.858-3.589-2.242l-.014.002c-.411-.822-.837-1.296-1.3-1.448-.457-.148-1.077-.022-1.885.396l-.012-.01a3.97 3.97 0 0 1-4.204-.327c-1.227-.906-1.84-2.418-1.603-3.95l-.012-.01c.28-1.802-.198-2.472-1.97-2.753l-.003-.016a4.033 4.033 0 0 1-3.208-2.773 4.117 4.117 0 0 1 .99-4.151l-.004-.014c1.27-1.29 1.27-2.117 0-3.408l.005-.014a4.117 4.117 0 0 1-.991-4.153 4.039 4.039 0 0 1 3.208-2.77l.004-.015c1.771-.285 2.25-.955 1.97-2.755l.013-.008c-.238-1.534.375-3.046 1.602-3.952a3.974 3.974 0 0 1 4.204-.328l.011-.008c.806.418 1.423.547 1.886.395.462-.152.888-.626 1.3-1.448l.015.002C16.108 1.858 17.481 1 18.998 1c1.518 0 2.893.858 3.59 2.242l.015-.002c.411.822.836 1.294 1.299 1.448.462.153 1.077.023 1.886-.395l.01.01a3.967 3.967 0 0 1 4.205.328c1.225.904 1.84 2.416 1.604 3.952l.013.007c-.282 1.8.197 2.47 1.969 2.756l.004.014a4.036 4.036 0 0 1 3.209 2.77 4.114 4.114 0 0 1-.99 4.154l.005.014c-1.27 1.289-1.27 2.117 0 3.407l-.006.015c1.08 1.1 1.46 2.69.99 4.153a4.038 4.038 0 0 1-3.21 2.77l-.002.016c-1.772.284-2.251.953-1.97 2.754l-.012.008c.235 1.535-.377 3.047-1.606 3.952a3.97 3.97 0 0 1-4.202.327l-.011.01c-.808-.42-1.424-.548-1.886-.396-.463.154-.888.627-1.3 1.447l-.015-.001c-.696 1.382-2.07 2.24-3.589 2.24Zm-2.2-2.974c.427.857 1.27 1.39 2.2 1.39.932 0 1.774-.531 2.2-1.39l.017.002c.607-1.208 1.328-1.935 2.205-2.221.873-.287 1.877-.13 3.066.484l.01-.01a2.424 2.424 0 0 0 2.583-.19 2.518 2.518 0 0 0 .979-2.44l.014-.009c-.407-2.636.659-4.123 3.254-4.546l.003-.015a2.475 2.475 0 0 0 1.984-1.696 2.53 2.53 0 0 0-.62-2.56l.004-.016c-1.855-1.89-1.855-3.727.001-5.616l-.006-.014c.673-.68.911-1.66.621-2.56a2.476 2.476 0 0 0-1.984-1.698l-.003-.014c-2.595-.425-3.661-1.911-3.254-4.548l-.014-.006a2.52 2.52 0 0 0-.977-2.441 2.428 2.428 0 0 0-2.584-.19l-.01-.01c-1.194.614-2.195.773-3.069.483-.875-.288-1.596-1.015-2.203-2.221H21.2c-.428-.859-1.27-1.39-2.202-1.39-.93 0-1.773.531-2.2 1.39h-.014c-.61 1.204-1.33 1.931-2.206 2.22-.875.288-1.876.13-3.067-.484l-.011.008a2.433 2.433 0 0 0-2.583.19 2.521 2.521 0 0 0-.976 2.443l-.015.008c.406 2.637-.659 4.123-3.255 4.546l-.003.014a2.479 2.479 0 0 0-1.983 1.698c-.29.9-.05 1.882.623 2.56l-.007.014c1.854 1.89 1.854 3.727 0 5.618l.007.014a2.528 2.528 0 0 0-.623 2.559c.288.9 1.047 1.55 1.983 1.697l.003.016c2.595.423 3.66 1.91 3.255 4.546l.013.01c-.152.95.222 1.883.977 2.44a2.43 2.43 0 0 0 2.584.19l.01.009c1.19-.613 2.192-.765 3.067-.485.875.288 1.596 1.015 2.205 2.221h.016Z"
              ></path>
              <path
                stroke="currentColor"
                stroke-width="0.702"
                d="M18.998 39c-1.518 0-2.89-.858-3.589-2.242l-.014.002c-.411-.822-.837-1.296-1.3-1.448-.457-.148-1.077-.022-1.885.396l-.012-.01a3.97 3.97 0 0 1-4.204-.327c-1.227-.906-1.84-2.418-1.603-3.95l-.012-.01c.28-1.802-.198-2.472-1.97-2.753l-.003-.016a4.033 4.033 0 0 1-3.208-2.773 4.117 4.117 0 0 1 .99-4.151l-.004-.014c1.27-1.29 1.27-2.117 0-3.408l.005-.014a4.117 4.117 0 0 1-.991-4.153 4.039 4.039 0 0 1 3.208-2.77l.004-.015c1.771-.285 2.25-.955 1.97-2.755l.013-.008c-.238-1.534.375-3.046 1.602-3.952a3.974 3.974 0 0 1 4.204-.328l.011-.008c.806.418 1.423.547 1.886.395.462-.152.888-.626 1.3-1.448l.015.002C16.108 1.858 17.481 1 18.998 1c1.518 0 2.893.858 3.59 2.242l.015-.002c.411.822.836 1.294 1.299 1.448.462.153 1.077.023 1.886-.395l.01.01a3.967 3.967 0 0 1 4.205.328c1.225.904 1.84 2.416 1.604 3.952l.013.007c-.282 1.8.197 2.47 1.969 2.756l.004.014a4.036 4.036 0 0 1 3.209 2.77 4.114 4.114 0 0 1-.99 4.154l.005.014c-1.27 1.289-1.27 2.117 0 3.407l-.006.015c1.08 1.1 1.46 2.69.99 4.153a4.038 4.038 0 0 1-3.21 2.77l-.002.016c-1.772.284-2.251.953-1.97 2.754l-.012.008c.235 1.535-.377 3.047-1.606 3.952a3.97 3.97 0 0 1-4.202.327l-.011.01c-.808-.42-1.424-.548-1.886-.396-.463.154-.888.627-1.3 1.447l-.015-.001c-.696 1.382-2.07 2.24-3.589 2.24Zm-2.2-2.974c.427.857 1.27 1.39 2.2 1.39.932 0 1.774-.531 2.2-1.39l.017.002c.607-1.208 1.328-1.935 2.205-2.221.873-.287 1.877-.13 3.066.484l.01-.01a2.424 2.424 0 0 0 2.583-.19 2.518 2.518 0 0 0 .979-2.44l.014-.009c-.407-2.636.659-4.123 3.254-4.546l.003-.015a2.475 2.475 0 0 0 1.984-1.696 2.53 2.53 0 0 0-.62-2.56l.004-.016c-1.855-1.89-1.855-3.727.001-5.616l-.006-.014c.673-.68.911-1.66.621-2.56a2.476 2.476 0 0 0-1.984-1.698l-.003-.014c-2.595-.425-3.661-1.911-3.254-4.548l-.014-.006a2.52 2.52 0 0 0-.977-2.441 2.428 2.428 0 0 0-2.584-.19l-.01-.01c-1.194.614-2.195.773-3.069.483-.875-.288-1.596-1.015-2.203-2.221H21.2c-.428-.859-1.27-1.39-2.202-1.39-.93 0-1.773.531-2.2 1.39h-.014c-.61 1.204-1.33 1.931-2.206 2.22-.875.288-1.876.13-3.067-.484l-.011.008a2.433 2.433 0 0 0-2.583.19 2.521 2.521 0 0 0-.976 2.443l-.015.008c.406 2.637-.659 4.123-3.255 4.546l-.003.014a2.479 2.479 0 0 0-1.983 1.698c-.29.9-.05 1.882.623 2.56l-.007.014c1.854 1.89 1.854 3.727 0 5.618l.007.014a2.528 2.528 0 0 0-.623 2.559c.288.9 1.047 1.55 1.983 1.697l.003.016c2.595.423 3.66 1.91 3.255 4.546l.013.01c-.152.95.222 1.883.977 2.44a2.43 2.43 0 0 0 2.584.19l.01.009c1.19-.613 2.192-.765 3.067-.485.875.288 1.596 1.015 2.205 2.221h.016Z"
                mask="url(#a)"
              ></path>
              <path
                fill="currentColor"
                stroke="currentColor"
                stroke-linejoin="round"
                stroke-width="0.351"
                d="M16.456 25.841c.034.04.083.063.135.063h1.34a.175.175 0 0 0 .134-.063l9.25-11.14a.176.176 0 0 0-.022-.248l-1.338-1.11a.176.176 0 0 0-.247.024l-8.447 10.172-4.1-4.938a.175.175 0 0 0-.247-.022l-1.337 1.11a.176.176 0 0 0-.023.248l4.902 5.904Z"
              ></path>
            </svg>
            Find local businesses and services.
          </h5>
          {/* <div class="NYYRT23FN7njtIQZApjR clCcZJyOogQLlUE0Q6WQ WbYyjehfGCadjRd7twsc">
            Um sicherzustellen, dass alle Nutzer:innen in deiner
            nebenan.de-Nachbarschaft vor Ort wohnen, verifizieren wir bei der
            Anmeldung die Adressen.
          </div> */}
        </div>
        <div class="lhe7D12ocC8dqa7nVWSl">
          <h5 class="pTxwDVMI6rC_geo2fLo8 EXJYCSOU5l6X2xNCgrfH j40Lpa_11jxj26o6XX_S">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox=".12 .35 30.37 39.29"
              class="eQtQSMDJkR4BT1TaqVTY"
            >
              <path
                fill="currentColor"
                stroke="currentColor"
                stroke-width="0.646"
                d="m16.322.793-.073.315.073-.315a4.501 4.501 0 0 0-2.033 0L2.026 3.637A1.83 1.83 0 0 0 .6 5.4C.59 7.24.55 8.963.514 10.579c-.042 1.844-.081 3.549-.07 5.134.024 2.996.229 5.641.945 8.165 1.437 5.067 4.93 9.473 12.773 15.08a1.973 1.973 0 0 0 2.287 0c7.842-5.607 11.339-10.013 12.776-15.08.716-2.524.92-5.17.942-8.165.012-1.58-.027-3.28-.07-5.117-.037-1.621-.077-3.35-.086-5.197a1.83 1.83 0 0 0-1.427-1.762L16.322.793Zm-1.685 1.452a2.96 2.96 0 0 1 1.337 0l12.263 2.844a.39.39 0 0 1 .17.133c.072.09.091.163.091.183.01 1.88.048 3.605.083 5.212.04 1.828.078 3.502.066 5.074-.023 2.938-.22 5.45-.881 7.783-1.318 4.648-4.488 8.759-12.204 14.277a.541.541 0 0 1-.258.05.533.533 0 0 1-.255-.047C7.332 32.236 4.163 28.125 2.845 23.477c-.662-2.333-.858-4.845-.88-7.784-.013-1.573.024-3.248.064-5.076.036-1.607.074-3.333.083-5.212 0-.02.02-.094.093-.183a.39.39 0 0 1 .169-.133l12.263-2.844Z"
              ></path>
              <path
                fill="currentColor"
                stroke="currentColor"
                stroke-width="0.646"
                d="M14.415 5.45a18.91 18.91 0 0 0-.419.104L7.043 7.27c-.021.006-.048.011-.078.018-.194.041-.554.118-.87.362a1.83 1.83 0 0 0-.57.744c-.152.364-.143.737-.138.941l.001.088.323.003-.323-.003c-.01 1.071-.032 2.084-.053 3.045-.03 1.383-.057 2.658-.043 3.845.024 2.02.169 3.825.634 5.556.935 3.482 3.163 6.523 8.004 10.29l.198-.255-.198.255.07.056c.147.12.387.317.693.422h.002a.682.682 0 0 0 .628-.102.706.706 0 0 0 .283-.566v-.002l.022-25.502c0-.312-.147-.597-.362-.786a.959.959 0 0 0-.851-.23Zm-.177 1.504L14.22 30.59c-4.314-3.454-6.155-6.122-6.954-9.097-.42-1.56-.556-3.242-.58-5.206a120.05 120.05 0 0 1 .041-3.804c.02-.95.04-1.961.05-3.046a4.783 4.783 0 0 1 .038-.514.451.451 0 0 1 .095-.126l.013-.005a4.225 4.225 0 0 1 .448-.143l6.867-1.696ZM6.82 8.9Z"
              ></path>
            </svg>
            All your data is procted
          </h5>
          <div class="NYYRT23FN7njtIQZApjR clCcZJyOogQLlUE0Q6WQ WbYyjehfGCadjRd7twsc">
            <span class="goodhood-components__2CSjw">
              <span class="goodhood-components__fqjAS">
                {/* <p>
                  Beim Datenschutz sind wir streng.{" "}
                  <a href="/privacy">Hier erfährst du mehr</a> darüber, wie wir
                  bei nebenan.de deine Daten schützen.
                </p> */}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features;
